import NextIcon from "../../images/Next.svg";
import { NavLink } from "react-router-dom";
import "./back.css";

export default function Back({ backPath, click }) {
  return backPath ? (
    <NavLink to={backPath}>
      <div className="back-button" onClick={click}>
        <img src={NextIcon} alt="back" />
      </div>
    </NavLink>
  ) : (
    <div className="back-button" onClick={click}>
      <img src={NextIcon} alt="back" />
    </div>
  );
}
